import {Loading} from "components/Loading/Loading";
import {useEffect, useState} from "react";
import ButtonCircle from "shared/Button/ButtonCircle";
import {useDeleteCardMutation, useGetCardsQuery} from "store/api";

export const MyCards = () => {
  const {data, isLoading} = useGetCardsQuery({});
  const [cards, setCards] = useState<any[]>([]);
  const [deleteCard] = useDeleteCardMutation();

  useEffect(() => {
    if (data && data.meta.status === 200) {
      setCards(data.data);
    }
  }, [data]);

  const handleDelete = async (tokenCard: string) => {
    try {
      const userId = JSON.parse(localStorage.getItem("user")!)?._id;
      const {data} = await deleteCard({userId, tokenCard});
      if (data.meta.status === 200) {
        setCards(cards.filter((card) => card.token !== tokenCard));
      }
    } catch (error) {
      console.error("Error deleting card:", error);
    }
  };

  if (isLoading) return <Loading />;
  if (cards.length === 0) return <span>No tienes tarjetas guardadas</span>;

  return (
    <div className="grid lg:grid-cols-2 gap-5 xl:gap-8 max-w-screen-lg mx-auto justify-items-center items-center">
      {cards.map((card, index) => (
        <div key={index} className="relative">
          {/* Botón eliminar */}
          <ButtonCircle
            onClick={() => handleDelete(card.token)}
            className="absolute -top-3 -right-3 bg-red-500 hover:bg-red-600 z-10 transform transition-all duration-300 ease-in-out hover:scale-110 text-white"
          >
            <i className="las la-trash text-xl"></i>
          </ButtonCircle>

          {/* Tarjeta */}
          <div
            className={`relative w-72 h-44 rounded-xl shadow-xl p-4 flex flex-col justify-between 
          backdrop-blur-s s:backdrop-blur-xl bg-white/10 bg-gradient-to-r from-gray-700/40 via-gray-500/30 to-gray-300/20 text-white transition-all duration-300 ease-in-out transform`}
          >
            <div className="text-sm font-semibold opacity-80 h-10"></div>
            <div className="absolute top-10 left-4 w-12 h-8 rounded-md bg-gradient-to-r from-yellow-500 to-yellow-300 shadow-md"></div>
            <div className="text-lg text-black dark:text-white font-mono tracking-widest mt-6">
              {"**** **** **** " + card.number}
            </div>
            <div className="flex justify-between items-center text-xs mt-2">
              <span className="uppercase text-black dark:text-white font-medium">
                {card.holder_name}
              </span>
              <span className="text-xs text-black dark:text-white font-semibold">
                {card.expiry_month +
                  "/" +
                  card.expiry_year.toString().slice(-2)}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
